import React from 'react';
import PropTypes from 'prop-types';

class Player extends React.Component {
  static propTypes = {
    details: PropTypes.shape({
      name: PropTypes.string,
      position: PropTypes.string,
      salary: PropTypes.number,
      age: PropTypes.string,
      selected: PropTypes.bool,
      synopsis: PropTypes.string,
      stats_2020: PropTypes.string,
      org_2020: PropTypes.string,
      signed: PropTypes.string,
      rfa: PropTypes.string,
    }),
    index: PropTypes.string,
    alterTeam: PropTypes.func,
    drafted: PropTypes.string,
  }

  nameRef = React.createRef();
  positionRef = React.createRef();
  salaryRef = React.createRef();
  playerRef = React.createRef();
  buttonRef = React.createRef();

  handleClick = (event) => {
    const player = {
      name: this.props.details.name,
      position: this.props.details.position,
      salary: this.props.details.salary,
      synopsis: this.props.details.synopsis,
      type: this.props.details.type,
    }

    const playerKey = this.props.index;
    const action = this.buttonRef.current.innerText;

    this.props.alterTeam(player, parseFloat(this.props.details.salary), playerKey, action)
  }

  alreadySigned = (signed) => {
    if (signed.length > 0) {
      return (
        <div className="signed__block">
          <p className="signed__label">Signed by</p>
          <img className="signed__logo" src={`./images/${signed}.jpg`} alt={signed} />
        </div>
      );
    } return null;
  }

  formatName = (name) => {
    return name.replace(/\s/g, '')
      .replace(/-/g, '')
      .replace(/'/g, '')
      .replace(/\./g, '')
      .replace(/’/g, '')
      .toLowerCase();
  }

  render () {

    const { name, age, position, salary, selected, synopsis, stats_2020, org_2020, signed, type, rfa } = this.props.details;

    const drafted = this.props.drafted;

    let salaryRow;

    if (salary > 0) {
      salaryRow = <li>Projected salary <span>${salary} million</span></li>
    } else {
      salaryRow = null;
    }

    let button;
    if (type !== 'draft' || drafted.length === 0) {
      button = <button ref={this.buttonRef} onClick={this.handleClick}>{selected ? 'Remove player' : 'Add player'}</button>;
    } else if (type === 'draft' && name === drafted) {
      button = <button ref={this.buttonRef} onClick={this.handleClick}>Remove player</button>;
    }

    return (
      <div ref={this.playerRef} className={`player${signed.length > 0 ? ' signed': ''}`}>
        <span className="player__pos">{position}</span>
        <img src={`./images/${this.formatName(name)}.jpg`} alt='' />
        <h5 ref={this.nameRef}>{name}</h5>
        <div className="player__details">
          <ul>
            <li>Age <span>{age}</span></li>
            {salaryRow}
            <li>2020 team <span>{org_2020}</span></li>

          </ul>
          {/* <table role="presentation">
            <tbody>
              <tr><td>Age</td><td>{age}</td></tr>
              {salaryRow}
              <tr><td>2020 team </td><td>{org_2020}</td></tr>
            </tbody>
          </table> */}
          <p>2020: {stats_2020}</p>
          <p className={rfa === 'x' ? 'player__synopsis rfa' : 'player__synopsis'}>     
            {synopsis}
          </p>
          {this.alreadySigned(signed)}
        </div>
        {button}
      </div>
    )
  }
}

export default Player;